export class Header {
  constructor(
    public title: string,
    public value: string,
    public width: number = -1,
    public isVisible: boolean = true) {
  }

  public filterText: string = null;
  public filterItems: string[] = [];

  clearFilter(): void {
    this.filterText = null;
    this.filterItems = [];
  }

  clone(): Header {
    return new Header(this.title, this.value, this.width, this.isVisible);
  }
}
